import React,{ Component } from 'react';
import { withRouter } from 'react-router';

import Overview from '../../overview/overview.component';
import Questions from '../../questions/question.component';
import Record from '../../record/record.component';
import Preview from '../../preview/preview.component';

// styles and icons
import { Row , Container , Col , Nav , Tab } from 'react-bootstrap';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DescriptionIcon from '@material-ui/icons/Description';
import HelpIcon from '@material-ui/icons/Help';
import MovieIcon from '@material-ui/icons/Movie';
import CheckIcon from '@material-ui/icons/Check';
import './create-biography.style.css';

// this component represents create visume/biography page

class CreateBiography extends Component{
    constructor (props){
        super(props);
        this.state = {
            updatedBio : ''
        }
    }
    componentWillReceiveProps(currentProps , nextProps){
        console.log(currentProps);
        console.log(nextProps);
    }
    componentDidMount(){
        this.connect();
        // get data from props in case of edit visume 
        console.log(this.props)
        if(this.props && this.props.location && this.props.location.state){
            localStorage.setItem('updatedBio', JSON.stringify(this.props.location.state.data))
            this.setState({ ...this.state, updatedBio:  JSON.parse(localStorage.getItem('updatedBio')) , status :this.props.location.state.status });
        }
        // get data from localstorage 
        else if (localStorage.getItem('updatedBio')){
            this.setState({ ...this.state, updatedBio:  JSON.parse(localStorage.getItem('updatedBio')) , status : "Save Changes"});
        }
        // make all left links disabled 
        let list = document.getElementById("left-tabs-example");
        let nav_items = list.querySelectorAll(".nav-item a");
        window.setInterval(function () {
            for(let i = 0 ; i < nav_items.length ; i++){
            nav_items[i].setAttribute("aria-disabled","true")
            nav_items[i].classList.add("disabled")
            } 
        },100)        
    }
    timeout = 250;
    // websocket 
    connect = () => {
        var ws = new WebSocket("wss://spreago.black-squares.com:6001/app/websocket?protocol=7&client=js&version=4.3.1&flash=false");
        let that = this; // cache the this
        var connectInterval;

        // websocket onopen event listener
        ws.onopen = () => {
            ws.send('{"event":"pusher:subscribe","data":{"channel":"bio"}}');
            ws.send('{"event":"pusher:subscribe","data":{"channel":"video"}}');
            that.timeout = 250; // reset timer to 250 on open of websocket connection 
            clearTimeout(connectInterval); // clear Interval on on open of websocket connection
        };
        // websocket onclose event listener
        ws.onclose = e => {
            console.log(
                `Socket is closed. Reconnect will be attempted in ${Math.min(
                    10000 / 1000,
                    (that.timeout + that.timeout) / 1000
                )} second.`,
                e.reason
            );

            that.timeout = that.timeout + that.timeout; //increment retry interval
            connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
        };
        // websocket message 
        let user_id = JSON.parse(localStorage.getItem('jwt')).user.id || localStorage.getItem('jwt').user.id
        ws.onmessage = evt => { 
           let newData = JSON.parse(evt.data);

            if(newData.event === "bioEdit"){
                let newBiography = JSON.parse(newData.data).bio;
                if(newBiography.user_id === user_id){
                    localStorage.setItem('updatedBio', JSON.stringify(newBiography))
                    that.setState({ ...that.state, updatedBio:  JSON.parse(localStorage.getItem('updatedBio')) });
                }
            }
            else if(newData.event === "bioUnderProcess"){
                let bioOnProcess = JSON.parse(newData.data).bio;
                if(bioOnProcess.user_id === user_id){
                   if(bioOnProcess.id === this.state.updatedBio.id){
                   }
                }
            }
            else if(newData.event === "bioProcessDone"){
                let bioProcessDone = JSON.parse(newData.data).bio;
                if(bioProcessDone.user_id === user_id){
                   if(bioProcessDone.id === this.state.updatedBio.id){
                      localStorage.setItem('updatedBio', JSON.stringify(bioProcessDone))
                      that.setState({ ...that.state, updatedBio:  bioProcessDone});  
                   }
                }
            }
        }
        // websocket onerror event listener
        ws.onerror = err => {
            console.error(
                "Socket encountered error: ",
                err.message,
                "Closing socket"
            );
            ws.close();
        };
    };
    /**
     * utilited by the @function connect to check if the connection is close, if so attempts to reconnect
     */
    check = () => {
        const { ws } = this.state;
        if (!ws || ws.readyState === WebSocket.CLOSED) this.connect(); //check if websocket instance is closed, if so call `connect` function.
    };
    render(){          
       return(
            <div className="createBiography">
            <Container  className="pt-4 container-fluid-responsive m-h-100">
                <Tab.Container  defaultActiveKey="first">
                        <Row className="m-0 pt-xs-4">
                            <Col sm={3}>
                                    <Nav variant="pills" id="left-tabs-example" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="first" className="row m-0">
                                                    <Row className="m-0">
                                                        <Col xs={3} ><DescriptionIcon/></Col>
                                                        <Col xs={5} className="p-0 pt-1">Overview </Col>
                                                        <Col xs={4} className="text-right"><CheckCircleIcon/></Col>
                                                    </Row>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="second">
                                                <Row className="m-0">
                                                        <Col xs={3} ><HelpIcon/></Col>
                                                        <Col xs={5} className="p-0 pt-1">Question </Col>
                                                        <Col xs={4} className="text-right"><CheckCircleIcon/></Col>
                                                    </Row>
                                                </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="third">
                                                <Row className="m-0">
                                                        <Col xs={3} ><MovieIcon/></Col>
                                                        <Col xs={5} className="p-0 pt-1">Record </Col>
                                                        <Col xs={4} className="text-right"><CheckCircleIcon/></Col>
                                                </Row>
                                                </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="forth">
                                                <Row className="m-0">
                                                        <Col xs={3} ><CheckIcon/></Col>
                                                        <Col xs={5} className="p-0 pt-1"> Review & publish </Col>
                                                        <Col xs={4} className="text-right"><CheckCircleIcon/></Col>
                                                    </Row>
                                                </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                            <Col sm={9} id="tab-content-container">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="first">
                                           <Overview data={this.state.updatedBio} status={this.state.status}/>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="second" >
                                            <Questions data={this.state.updatedBio} status={this.state.status}/>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="third" >
                                            {/* <Record data={this.state.updatedBio} videoStatus={this.state.videoStatus} status={this.state.status}/> */}
                                            <Record data={this.state.updatedBio}  status={this.state.status}/>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="forth" >
                                            <Preview data={this.state.updatedBio} status={this.state.status}/>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                </Tab.Container>
            </Container>
            </div>
        );
    }
}

export default withRouter(CreateBiography);